export default __webpack_public_path__ + "static/media/customerSupport.43b9cf34.svg";